import React from "react";
import { Row, Col, Modal, Button, Form } from "@themesberg/react-bootstrap";
import { useState } from "react";

const ModalVerificationDialog = ({ cb, ...props }) => {
  const [reason, setReason] = useState("");
  const [isRevised, setIsRevised] = useState(false);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={props.onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Verifikasi?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isRevised ? (
          <Form>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Alasan</Form.Label>
              <Form.Control
                type="text"
                placeholder="masukkan alasan revisi"
                value={reason || ""}
                required
                onChange={(e) => {
                  setReason(e.target.value);
                }}
                autoFocus
              />
            </Form.Group>
            <Row className="justify-content-end">
              <Col xs="auto">
                <Button variant="success" onClick={() => cb(2, reason)}>
                  Simpan
                </Button>
              </Col>
              <Col xs="auto">
                <Button variant="warning" onClick={() => setIsRevised(false)}>
                  Batal
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Row className="justify-content-center">
            <Col xs="auto">
              <Button variant="success" onClick={() => cb(1, "")}>
                Setujui
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="warning" onClick={() => setIsRevised(true)}>
                Revisi
              </Button>
            </Col>
            <Col xs="auto">
              <Button variant="danger" onClick={() => cb(3, "")}>
                Tolak
              </Button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalVerificationDialog;
